import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export interface TaxFeedLogListGridActionCellRendererParams extends ICellRendererParams {
    viewDetails: (params: TaxFeedLogListGridActionCellRendererParams) => void;
}

@Component({
    selector: 'tax-feed-log-grid-action-cell',
    template:
        `@if (taxFeedSummaryLog) {
  <button type="button"
    class="ace-btn btn-primary has-icon grid-action-button"
    (click)="params.viewDetails(params)"
    helpTooltip
    helpContentId="app.view"
    position="bottom">
    <i class="fa fa-pencil"></i>
  </button>
}`,
    standalone: false
})
export class TaxFeedLogListGridActionCellRendererComponent implements ICellRendererAngularComp {
    params: TaxFeedLogListGridActionCellRendererParams;
    taxFeedSummaryLog: Core.TaxFeedSummaryLogModel;

    agInit(params: TaxFeedLogListGridActionCellRendererParams): void {
        this.params = params;
        this.taxFeedSummaryLog = params.data as Core.TaxFeedSummaryLogModel;
    }

    refresh(): boolean {
        return false; // tells grid to handle refreshing
    }
}
